import { handleActions } from 'redux-actions';

const INITIAL_STATE = {
  is_subscribed: false,
  show_newsletter_modal: false,
  dont_display_newsletter_modal_again: false,
};

/**
 * config in state
 */
export const config = handleActions(
  {
    SUBSCRIBED: (state, action) => {
      return Object.assign({}, state, {
        is_subscribed: true,
        show_newsletter_modal: false,
      });
    },
    SHOW_NEWSLETTER_MODAL: (state, action) => {
      return Object.assign({}, state, {
        show_newsletter_modal: true,
      });
    },
    HIDE_NEWSLETTER_MODAL: (state, action) => {
      return Object.assign({}, state, {
        show_newsletter_modal: false,
        dont_display_newsletter_modal_again: true,
      });
    },
  },
  INITIAL_STATE
);



// WEBPACK FOOTER //
// ./src/reducers/config.js